<template>
  <v-container class="searchBar pb-2 px-0 pt-2">
    <v-form lazy-validation @submit.prevent="manualClick()">
      <v-layout row wrap column justify-start>
        <div>
          <v-text-field v-model="options.query" label="Search" type="text" class="textField" color="primary">
            <v-fade-transition slot="append">
              <v-progress-circular v-if="isLoading" size="24" color="primary" indeterminate></v-progress-circular>
            </v-fade-transition>
            <v-btn fab flat small style="top: -1.2rem" color="primary" slot="prepend" @click.prevent="clearAllClick">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-btn slot="append-outer" style="top: -1.2rem" offset-y flat fab small color="primary" @click.stop="dropdownToggle" v-if="false">
              <v-icon>{{ dropdown ? 'mdi-chevron-up' : 'mdi-menu' }}</v-icon>
            </v-btn>
            <div style="position:relative" slot="append-outer">
              <v-btn
                style="top: -1.2rem"
                offset-y
                flat
                fab
                small
                color="primary"
                class="searchButton"
                @click.prevent="manualClick()"
                @keyup.enter.prevent="manualClick()"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
              <div class="activeIcon" v-if="eventsGetAdvance">active</div>
            </div>
          </v-text-field>
        </div>
        <transition name="slide">
          <v-container fluid class="pl-0 pr-3 py-0" v-if="dropdown">
            <v-layout row wrap align-center>
              <v-flex xs12 sm3> <div class="subHeader pl-3">Start Time</div> </v-flex>
              <v-flex xs12 sm9 class="pr-1">
                <v-text-field
                  class="inputFields"
                  v-model="options.startTime"
                  type="datetime-local"
                  color="primary"
                  append-icon="mdi-calendar-range"
                  max="9999-12-31T23:59"
                  @keyup.enter.prevent="submit(true)"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3> <div class="subHeader pl-3">End Time</div> </v-flex>
              <v-flex xs12 sm9 class="pr-1">
                <v-text-field
                  class="inputFields"
                  v-model="options.endTime"
                  type="datetime-local"
                  color="primary"
                  append-icon="mdi-calendar-range"
                  max="9999-12-31T23:59"
                  @keyup.enter.prevent="submit(true)"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 v-if="false"> <div class="subHeader pl-3">Sort By</div> </v-flex>
              <v-flex xs12 sm9 class="pr-1" v-if="false">
                <v-select
                  v-model="options.sort"
                  class="inputFields"
                  :items="sortBy"
                  item-text="name"
                  item-value="value"
                  label="Select"
                  single-line
                  append-icon="mdi-sort"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm3 v-if="false"> <div class="subHeader pl-3">Category</div> </v-flex>
              <v-flex xs12 sm9 class="pr-1" v-if="false">
                <v-select
                  v-model="options.eventCategory"
                  class="inputFields"
                  :items="category"
                  item-text="name"
                  item-value="value"
                  label="Select a type of category"
                  placeholder="Police, Health, and Natural Disaster"
                  multiple
                  chips
                  append-icon="mdi-shape"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip :selected="data.selected" color="primary" close @input="removeCategory(data.item)" class="white--text chip--select-multi">
                      <v-icon left>{{ data.item.icon }}</v-icon>
                      <span v-text="data.item.name"></span>
                    </v-chip>
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs12 sm3 v-if="false"> <div class="subHeader pl-3">Location</div> </v-flex>
              <v-flex xs12 sm9 class="pr-1">
                <v-combobox
                  class="autocomplete"
                  v-model="options.locationCode"
                  :items="items"
                  :loading="autoCompleteLoading"
                  :search-input.sync="search"
                  hide-no-data
                  chips
                  type="text"
                  multiple
                  item-text="Description"
                  clearable
                  return-object
                  label="Region"
                  placeholder="Start typing to Search region"
                  color="primary"
                  append-icon="mdi-map-marker"
                  @keyup.enter.prevent="submit(true)"
                  v-if="false"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip :selected="data.selected" color="primary" close @input="remove(data.item)" class="white--text chip--select-multi">
                      <v-icon left>mdi-map-marker-circle</v-icon>
                      <span v-text="data.item._source.shortname"></span>
                    </v-chip>
                  </template>
                  <template slot="item" slot-scope="data">
                    <v-list-tile-avatar color="primary" class="headline font-weight-light white--text">{{
                      data.item._source.shortname.charAt(0)
                    }}</v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="data.item._source.fullname"></v-list-tile-title>
                      <v-list-tile-sub-title v-text="data.item._source.LOCATION_TYPE"></v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action> <v-icon>mdi-map-marker-circle</v-icon> </v-list-tile-action>
                  </template>
                </v-combobox>
              </v-flex>
              <v-flex xs12 sm3 v-if="false"> <div class="subHeader pl-3">Importance</div> </v-flex>
              <v-flex xs12 sm9 class="pr-1" v-if="false">
                <v-select
                  v-model="options.eventImportance"
                  class="inputFields"
                  :items="importance"
                  item-text="name"
                  item-value="value"
                  label="Select an importance"
                  placeholder="Information, Warning, or Critical"
                  multiple
                  chips
                  append-icon="mdi-chart-donut-variant"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                      :selected="data.selected"
                      :color="data.item.color"
                      close
                      @input="removeImportance(data.item)"
                      class="white--text chip--select-multi"
                    >
                      <v-icon left>{{ data.item.icon }}</v-icon>
                      <span v-text="data.item.name"></span>
                    </v-chip>
                  </template>
                </v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </transition>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SearchBar',
  computed: {
    ...mapGetters({
      isLoading: 'isLoading',
      entries: 'entries',
      autoCompleteLoading: 'autoCompleteLoading',
      eventsGetAdvance: 'eventsGetAdvance'
    }),
    items() {
      if (typeof this.entries === 'undefined') return;
      if (this.entries == null) return;
      return this.entries.map(entry => {
        const Description =
          entry._source.fullname.length > this.descriptionLimit
            ? entry._source.fullname.slice(0, this.descriptionLimit) + '...'
            : entry._source.fullname;
        return Object.assign({}, entry, { Description });
      });
    }
  },
  watch: {
    search(val) {
      if (this.autoCompleteLoading) return;
      if (this.search === null || typeof val === 'undefined') return;
      this.$store.dispatch('autoComplete', this.search);
    },
    'options.locationCode'(newval, oldval) {
      if (newval !== oldval || newval.length == 0) {
        this.search = '';
      }
    }
  },
  data() {
    return {
      dropdown: false,
      category: [
        { value: 'Plc', name: 'Police', icon: 'mdi-star-circle' },
        { value: 'Hlt', name: 'Health', icon: 'mdi-medical-bag' },
        { value: 'ND', name: 'Natural Disasters', icon: 'mdi-weather-hurricane' }
      ],
      importance: [
        { value: 'Information', name: 'Information', icon: 'mdi-information', color: 'info' },
        { value: 'Warning', name: 'Warning', icon: 'mdi-alert', color: 'warning' },
        { value: 'Critical', name: 'Critical', icon: 'mdi-alert-decagram', color: 'critical' }
      ],
      sortBy: [
        { value: 'timestamp+desc', name: 'Timestamp Descending' },
        { value: 'timestamp+asc', name: 'Timestamp Ascending' },
        { value: 'magnitude+desc', name: 'Magnitude Descending' },
        { value: 'magnitude+asc', name: 'Magnitude Ascending' },
        { value: 'default', name: 'Default' }
      ],
      options: {
        query: '',
        startTime: '',
        endTime: '',
        sort: '',
        eventCategory: [],
        eventRegion: [],
        locationCode: [],
        eventImportance: [],
        initial: true,
        advance: false
      },
      descriptionLimit: 60,
      search: ''
    };
  },
  mounted() {
    setInterval(() => {
      this.$store.dispatch('eventsLoadPull');
    }, 1000 * 60 * 1.5);
  },
  methods: {
    dropdownToggle() {
      this.dropdown = !this.dropdown;
    },
    remove(item) {
      const index = this.options.locationCode.indexOf(item);
      if (index >= 0) this.options.locationCode.splice(index, 1);
    },
    removeCategory(item) {
      const index = this.options.eventCategory.indexOf(item.value);
      if (index >= 0) this.options.eventCategory.splice(index, 1);
    },
    removeImportance(item) {
      const index = this.options.eventImportance.indexOf(item.value);
      if (index >= 0) this.options.eventImportance.splice(index, 1);
    },
    clearAll() {
      this.search = '';
      this.options.query = '';
      this.options.startTime = '';
      this.options.endTime = '';
      this.options.sort = '';
      this.locationName = [];
      this.options.locationCode = [];
      this.options.eventCategory = [];
      this.options.eventImportance = [];
      this.$store.commit('eventsClearEntries');
      this.submit(true);
    },
    clearAllClick() {
      this.search = '';
      this.options.query = '';
      this.options.startTime = '';
      this.options.endTime = '';
      this.options.sort = '';
      this.locationName = [];
      this.options.locationCode = [];
      this.options.eventCategory = [];
      this.options.eventImportance = [];
      this.$store.commit('eventsClearEntries');
      this.manualClick();
    },
    manualClick() {
      this.dropdown = false;
      this.submit(true);
      this.$ga.event('send', {
        eventCategory: 'Query',
        eventAction: `Clicked with ${this.options.query}`
      });
    },
    submit(initialSwitch) {
      this.$store.dispatch('search', {
        query: this.options.query,
        startTime: this.options.startTime,
        endTime: this.options.endTime,
        sort: this.options.sort,
        eventCategory: this.options.eventCategory,
        eventRegion: this.options.eventRegion,
        locationCode: this.options.locationCode,
        eventImportance: this.options.eventImportance,
        initial: initialSwitch
      });
    }
  }
};
</script>

<style scoped>
.searchButton {
  position: relative;
}
.activeIcon {
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  background: #4caf50;
  position: absolute;
  top: 1.1rem;
  right: 0.2rem;
  color: white;
  padding: 1px 10px;
  font-size: 0.7rem;
}
.inputFields {
  font-size: 1.1rem;
}
.autocomplete {
  z-index: 9999;
}
.slide-enter-active {
  transition: all 0.6s ease;
}
.slide-leave-active {
  transition: all 0.25s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateY(-1rem);
  opacity: 0;
}
</style>
